import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Whatsapp from "../components/Whatsapp";
import Footer from "../components/Footer";
import banner1 from "../assets/images/projects.jpg";
import apartmentImg from "../assets/images/apartment1.png";

import g2Img from "../assets/images/g2.jpg";
import g4Img from "../assets/images/cpimg4.jpg";
import houseImg from "../assets/images/cpimg2.jpg";
import villaImg from "../assets/images/cpimg3.jpg";
import plotImg from "../assets/images/cpimg.jpg";
import apartment2Img from "../assets/images/cpimg1.jpg";
import brochure1 from "../assets/images/brochure-1.pdf";
import brochure2 from "../assets/images/Venkat Enclave Brochure_27-09-22-V1.pdf";
import brochure3 from "../assets/images/1.pdf";
import brochure4 from "../assets/images/2.pdf";
import brochure5 from "../assets/images/3.pdf";

import "../assets/css/style.css";

const completedProjects = [
  {
    id: 1,
    name: "Santhosh Nagar Apartments",
    location: "Konthamuru, Rajamahendravaram",
    brochure: brochure1,
    image: apartmentImg,
    type: "Residential Flats",
    units: "15 Flats",
    status: "Completed & Handed Over",
    description: "All East-facing residential flats in Konthamuru, Rajamahendravaram. 3 flats per floor across 5 floors, located just 7 KM from the airport for excellent connectivity and convenience.",
    highlights: [
      "Total 15 Flats",
      "5 Floors × 3 Flats per Floor",
      "All East-Facing",
      "Airport Distance: Just 7 KM",
    ],
    specs: {
      Floors: "5 Floors",
      "Flats per Floor": "3 Flats",
      "Total Units": "15 Flats",
      Facing: "All East-Facing",
      "Nearest Airport": "7 KM"
    },
    features: ["Lift Facility", "Car Parking", "24/7 Water Supply", "Power Backup"],
  },
  {
    id: 2,
    name: "Venkat Enclave",
    location: "East Railway Station Road, Opp. Sri Aditya Inn, Rajamahendravaram",
    brochure: brochure2,
    image: g2Img,
    type: "Luxury Apartments",
    units: "80 Flats",
    status: "Completed & Handed Over",
    description: "Developed by Vaahini Developers (RJY), Venkat Enclave is a premium gated community on East Railway Station Road opposite Sri Aditya Inn. Featuring 80 well-designed 2 & 3 BHK apartments across 5 floors (16 flats per floor), with carefully chosen flat configurations including all East-facing 3 BHK premium units.",
    highlights: [
      "Developer: Vaahini Developers, RJY",
      "Total 80 Flats in 5 Floors",
      "16 Flats per Floor",
      "3 BHK: 20 Units · 2 BHK: 60 Units",
    ],
    specs: {
      Developer: "Vaahini Developers, RJY",
      Floors: "5 Floors",
      "Flats per Floor": "16 Flats",
      "Total Units": "80 Flats",
      "3 BHK Count": "20 Flats",
      "3 BHK Flat Area": "1537 Sft",
      "3 BHK Land Area": "66.50 Sq. Yards",
      "3 BHK Flat Nos": "13, 14, 16",
      "3 BHK Facing": "All East-Facing",
      "2 BHK Count": "60 Flats",
      "2 BHK Flat Area": "1157 to 1241 Sft",
      "2 BHK Land Area": "50.10 to 53.66 Sq. Yards",
      "2 BHK Flat Nos": "01 to 12",
      "2 BHK Facing": "East, West & North-Facing",
    },
    features: ["Multipurpose Community Hall", "Gymnasium", "Children's Play Area", "CCTV Surveillance", "24/7 Security", "Covered Car Parking", "Power Backup", "Rain Water Harvesting"],
  },
  {
    id: 3,
    name: "Devi Sai Arcade",
    location: "Burugupudi, Rajamahendravaram (Airport: Just 2 KM)",
    brochure: brochure5,
    image: plotImg,
    type: "DTCP Approved Layout",
    units: "3 Acres Layout",
    status: "Completed & Handed Over",
    description: "Devi Sai Arcade is a premium DTCP-approved residential layout spanning 3 acres in Burugupudi, Rajamahendravaram. Strategically located just 2 KM from the airport, this plotted development offers excellent connectivity and premium infrastructure for families looking to build their dream home in a rapidly growing locality.",
    highlights: [
      "Total Layout Area: 3 Acres",
      "DTCP Fully Approved Layout",
      "Airport Distance: Just 2 KM",
      "Premium Infrastructure & Roads",
    ],
    specs: {
      "Layout Area": "3 Acres",
      Approval: "DTCP Approved",
      "Nearest Airport": "2 KM",
      Location: "Burugupudi, Rajamahendravaram",
      "Road Width": "40 Feet & 30 Feet",
      "Underground Drainage": "Available",
      "Water Supply": "24/7 Available",
      "Street Lighting": "Solar Street Lights",
    },
    features: ["DTCP Approved", "Underground Drainage", "Water Supply", "Avenue Plantation", "Solar Street Lights", "Compound Wall", "Clear Title", "Excellent Connectivity"],
  },
  {
    id: 4,
    name: "Raja Rajeswari Nagar Residences",
    location: "Konthamuru, Raja Rajeswari Nagar 2, Rajamahendravaram",
    image: apartment2Img,
    type: "Residential Flats",
    units: "6 Flats",
    status: "Completed & Handed Over",
    description: "A compact and elegant residential apartment project in Raja Rajeswari Nagar Phase 2, Konthamuru. Built on a spacious 240 sq.yards plot with 2 thoughtfully designed flats per floor across 3 floors, totaling 6 premium flats. Featuring both East and West-facing options to suit every family's preferences.",
    highlights: [
      "Plot Size: 240 Sq. Yards",
      "Total 6 Flats in 3 Floors",
      "2 Flats per Floor",
      "East & West-Facing Flats",
    ],
    specs: {
      "Plot Area": "240 Sq. Yards",
      Floors: "3 Floors",
      "Flats per Floor": "2 Flats",
      "Total Units": "6 Flats",
      Facing: "East & West-Facing",
      Location: "Konthamuru, Raja Rajeswari Nagar 2",
    },
    features: ["Car Parking", "24/7 Water Supply", "Lift Facility", "Power Backup", "Ventilation & Natural Light", "Premium Fittings", "Kids Play Area", "Well Connected Roads"],
  },
  {
    id: 5,
    name: "2 BHK Independent Houses",
    location: "Konthamuru, Raja Rajeswari Nagar, Rajamahendravaram",
    image: houseImg,
    type: "2 BHK Independent Houses",
    units: "Independent Villas",
    status: "Completed & Handed Over",
    description: "Exclusive 2 BHK independent houses situated in the heart of Konthamuru's Raja Rajeswari Nagar. Each villa is carefully constructed on a spacious 140 sq.yards plot with private outdoor space, ensuring privacy and comfort for every family member. Designed for modern living with all essential amenities nearby.",
    highlights: [
      "2 BHK Independent Houses",
      "Plot Size: 140 Sq. Yards Each",
      "Private House with Personal Space",
      "Prime Konthamuru Location",
    ],
    specs: {
      Type: "2 BHK Independent House",
      "Plot Area": "140 Sq. Yards Each",
      Location: "Konthamuru, Raja Rajeswari Nagar",
      "Bedrooms": "2 Bedrooms",
      "Private Open Space": "Available",
      "Parking": "Individual Car Parking",
      Facing: "Vastu-Compliant",
    },
    features: ["Independent Compound", "Car Parking", "24/7 Borewell Water", "Power Backup", "Granite Kitchen Platform", "Premium Tile Flooring", "Well-Ventilated Rooms", "Peaceful Residential Area"],
  },
  {
    id: 6,
    name: "Santosh Nagar Group Housing & Villas",
    location: "Konthamuru, Santosh Nagar Road, Rajamahendravaram",
    brochure: brochure3,
    image: villaImg,
    type: "Group House & Duplex Villas",
    units: "1 Group House + 2 Duplex",
    status: "Completed & Handed Over",
    description: "A unique mixed residential development on Santosh Nagar Road in Konthamuru featuring 1 spacious group house and 2 luxurious duplex houses. Each property is crafted with premium specifications, modern architecture, and ample private space to deliver the perfect blend of community living and individual privacy.",
    highlights: [
      "1 Spacious Group House",
      "2 Luxury Duplex Villas",
      "Santosh Nagar Road Frontage",
      "Modern Premium Construction",
    ],
    specs: {
      "Group Houses": "1 Unit",
      "Duplex Villas": "2 Units",
      Location: "Konthamuru, Santosh Nagar Road",
      "Duplex Floors": "Ground + 2 Floors",
      "Group House Type": "Shared Community Spaces",
      Facing: "Vastu Oriented",
    },
    features: ["Private Entrances", "Stilt Car Parking", "24/7 Water Supply", "Power Backup Provision", "Rooftop Terrace for Duplex", "Premium Bathrooms & Fittings", "Modular Kitchen", "Close to Schools & Markets"],
  },
  {
    id: 7,
    name: "Dhana Sri Enclave",
    location: "Lalacheruvu, Revenue Colony, Beside Shashi School, Rajamahendravaram",
    brochure: brochure4,
    image: g4Img,
    type: "Premium Residential Enclave",
    units: "Gated Community",
    status: "Completed & Handed Over",
    description: "Dhana Sri Enclave is a fully completed premium residential enclave in the well-established Lalacheruvu Revenue Colony, strategically located right beside Shashi School. This thoughtfully designed community offers a perfect blend of serene living with urban convenience, surrounded by reputed educational institutions, shopping centers, and all daily necessities within walking distance.",
    highlights: [
      "Beside Shashi School",
      "Lalacheruvu Revenue Colony",
      "Fully Completed & Occupied",
      "Family-Friendly Community",
    ],
    specs: {
      Location: "Lalacheruvu Revenue Colony",
      Landmark: "Beside Shashi School",
      Community: "Gated Enclave",
      Status: "Fully Completed & Handed Over",
      "Nearby Schools": "Shashi School, Multiple Schools",
      Markets: "Walking Distance",
      Connectivity: "Excellent Road Network",
    },
    features: ["Gated Community", "24/7 Security", "Underground Cabling", "Water Supply", "Avenue Plantation", "Rain Water Harvesting", "Street Lighting", "Close to Schools & Hospitals"],
  },
];

const CompletedProjects = () => {
  const [selectedProject, setSelectedProject] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const filteredProjects = completedProjects.filter((project) => {
    return (
      project.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      project.location.toLowerCase().includes(searchTerm.toLowerCase())
    );
  });

  const handleBrochureDownload = (project) => {
    window.open(project.brochure, "_blank");

    const link = document.createElement("a");
    link.href = project.brochure;
    link.download = `${project.name.replace(/\s+/g, "-")}-brochure.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div>
      <Navbar />
      <div className="project-banner" style={{ backgroundImage: `url(${banner1})`, marginTop: "125px" }}></div>

      <div className="projects-section py-5">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="projects-title mb-3">Completed Projects</h2>
            <p className="custom-text text-center mx-auto" style={{ maxWidth: "750px" }}>
              A legacy of successfully delivered projects built with trust, quality, and excellence.
              Every project stands as a testament to our commitment to creating spaces where families thrive.
            </p>
          </div>

          <div className="row justify-content-center mb-5 g-3">
            <div className="col-md-6 col-lg-4">
              <div className="input-group shadow-sm border rounded">
                <span className="input-group-text bg-white border-0">
                  <i className="fas fa-search" style={{ color: "#b8860b" }}></i>
                </span>
                <input
                  type="text"
                  className="form-control border-0 shadow-none py-2"
                  placeholder="Search by project name or location..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="row">
            {filteredProjects.length === 0 ? (
              <div className="col-12 text-center py-5">
                <i className="fas fa-folder-open fs-1 mb-3" style={{ color: "#ccc" }}></i>
                <p className="text-muted fs-5">No projects match your search criteria.</p>
              </div>
            ) : (
              filteredProjects.map((project) => (
                <div key={project.id} className="col-lg-4 col-md-6 mb-4">
                  <div className="card h-100 shadow-sm border-0 project-card" style={{ borderRadius: "0px", overflow: "hidden" }}>
                    <div className="position-relative">
                      <img
                        src={project.image}
                        alt={project.name}
                        className="card-img-top"
                        style={{ height: "240px", objectFit: "cover", width: "100%" }}
                      />
                      <span
                        className="position-absolute top-0 end-0 m-3 px-3 py-1 text-white fw-semibold shadow"
                        style={{ background: "#28a745", fontSize: "0.85rem" }}
                      >
                        <i className="fas fa-check-circle me-1"></i>Completed
                      </span>
                      <span
                        className="position-absolute top-0 start-0 m-3 px-3 py-1 text-white fw-semibold"
                        style={{ background: "rgba(0,0,0,0.6)", fontSize: "0.8rem" }}
                      >
                        {project.type}
                      </span>
                    </div>
                    <div className="card-body p-4 d-flex flex-column">
                      <h5 className="card-title mb-2 fw-bold" style={{ color: "#1a1a1a" }}>{project.name}</h5>
                      <p className="mb-2 fs-6" style={{ color: "#666" }}>
                        <i className="fas fa-map-marker-alt me-2" style={{ color: "#dc3545" }}></i>
                        {project.location}
                      </p>
                      <div className="d-flex flex-wrap gap-3 mb-3 small justify-content-center">
                        <span style={{ color: "#555" }}>
                          <i className="fas fa-hotel me-1" style={{ color: "#b8860b" }}></i>
                          {project.units}
                        </span>
                        <span style={{ color: "#555" }}>
                          <i className="fas fa-calendar-check me-1" style={{ color: "#b8860b" }}></i>
                          {project.status}
                        </span>
                      </div>
                      <p className="card-text mb-4" style={{ color: "#666", fontSize: "0.95rem", lineHeight: "1.6" }}>
                        {project.description}
                      </p>
                      <div className="mb-4 p-3" style={{ background: "#fafafa", borderLeft: "3px solid #b8860b" }}>
                        {project.highlights && project.highlights.map((hl, idx) => (
                          <div key={idx} className="mb-2 d-flex align-items-start gap-2" style={{ fontSize: "0.9rem", color: "#333", lineHeight: "1.5" }}>
                            <i className="fas fa-arrow-right mt-1" style={{ color: "#b8860b", fontSize: "0.75rem", flexShrink: 0 }}></i>
                            <span>{hl}</span>
                          </div>
                        ))}
                      </div>
                      <div className="d-flex flex-wrap gap-2 mb-4">
                        {project.features && project.features.slice(0, 4).map((feature, idx) => (
                          <span
                            key={idx}
                            className="px-2 py-1 rounded"
                            style={{ background: "#faf6ec", color: "#b8860b", fontSize: "0.8rem" }}
                          >
                            {feature}
                          </span>
                        ))}
                      </div>
                      <div className={"d-flex gap-2 mt-auto " + (project.brochure ? "" : "w-100")}>
                        {project.brochure && (
                          <button
                            className="btn flex-fill"
                            onClick={() => handleBrochureDownload(project)}
                            style={{
                              background: "#b8860b",
                              color: "#fff",
                              border: "2px solid #b8860b",
                              borderRadius: "0px",
                              padding: "10px 16px",
                              fontWeight: "500",
                              transition: "all 0.3s ease",
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.background = "transparent";
                              e.target.style.color = "#b8860b";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.background = "#b8860b";
                              e.target.style.color = "#fff";
                            }}
                          >
                            <i className="fas fa-download me-2"></i>Brochure
                          </button>
                        )}
                        <button
                          className={project.brochure ? "btn flex-fill" : "btn w-100"}
                          onClick={() => setSelectedProject(project)}
                          style={{
                            background: "transparent",
                            color: "#1a1a1a",
                            border: "2px solid #1a1a1a",
                            borderRadius: "0px",
                            padding: "10px 16px",
                            fontWeight: "500",
                            transition: "all 0.3s ease",
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.background = "#1a1a1a";
                            e.target.style.color = "#fff";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.background = "transparent";
                            e.target.style.color = "#1a1a1a";
                          }}
                        >
                          <i className="fas fa-eye me-2"></i>View Details
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>

   
        </div>
      </div>

      {selectedProject && (
        <div
          className="modal fade show"
          style={{ display: "block", background: "rgba(0,0,0,0.6)", zIndex: "9999" }}
          onClick={() => setSelectedProject(null)}
        >
          <div
            className="modal-dialog modal-lg modal-dialog-centered"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content rounded-0 border-0 shadow-lg">
              <div className="modal-header border-0 pb-0">
                <div>
                  <h4 className="modal-title fw-bold mb-1" style={{ color: "#1a1a1a" }}>{selectedProject.name}</h4>
                  <p className="mb-0" style={{ color: "#666" }}>
                    <i className="fas fa-map-marker-alt me-2" style={{ color: "#dc3545" }}></i>
                    {selectedProject.location}
                  </p>
                </div>
                <button
                  type="button"
                  className="btn-close fs-5"
                  onClick={() => setSelectedProject(null)}
                  style={{ fontSize: "1.3rem" }}
                ></button>
              </div>
              <div className="modal-body p-4">
                <div className="row">
                  <div className="col-md-6 mb-4 mb-md-0">
                    <img
                      src={selectedProject.image}
                      alt={selectedProject.name}
                      className="w-100 mb-3"
                      style={{ height: "280px", objectFit: "cover" }}
                    />
                    <div className="d-flex flex-wrap gap-2 mb-3">
                      <span className="px-3 py-2" style={{ background: "#f0f8ff", color: "#007bff", fontWeight: "500" }}>
                        <i className="fas fa-hotel me-2"></i>{selectedProject.units}
                      </span>
                      <span className="px-3 py-2" style={{ background: "#e8f8f0", color: "#28a745", fontWeight: "500" }}>
                        <i className="fas fa-calendar-check me-2"></i>{selectedProject.status}
                      </span>
                    </div>
                    <h6 className="fw-semibold mb-2">Amenities:</h6>
                    <div className="row">
                      {selectedProject.features && selectedProject.features.map((feature, idx) => (
                        <div key={idx} className="col-6 mb-2">
                          <span style={{ color: "#555", fontSize: "0.9rem" }}>
                            <i className="fas fa-check-circle me-2" style={{ color: "#28a745" }}></i>
                            {feature}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <h5 className="fw-semibold mb-3" style={{ color: "#b8860b" }}>
                      <i className="fas fa-info-circle me-2"></i>Project Details
                    </h5>
                    <p style={{ color: "#555", lineHeight: "1.8" }}>{selectedProject.description}</p>
                    <h6 className="fw-semibold mt-4 mb-3">
                      <i className="fas fa-list me-2" style={{ color: "#b8860b" }}></i>Project Specifications:
                    </h6>
                    <div className="border rounded overflow-hidden mb-4" style={{ borderColor: "#eee" }}>
                      <table className="table table-sm mb-0" style={{ fontSize: "0.9rem" }}>
                        <tbody>
                          {selectedProject.specs && Object.entries(selectedProject.specs).map(([key, value], idx) => (
                            <tr key={idx} style={{ background: idx % 2 === 0 ? "#fafafa" : "#ffffff" }}>
                              <td
                                className="fw-semibold py-2 px-3"
                                style={{
                                  width: "45%",
                                  color: "#333",
                                  borderRight: "1px solid #eee",
                                  borderBottom: idx < Object.keys(selectedProject.specs).length - 1 ? "1px solid #eee" : "none",
                                }}
                              >
                                {key}
                              </td>
                              <td
                                className="py-2 px-3"
                                style={{
                                  color: "#555",
                                  borderBottom: idx < Object.keys(selectedProject.specs).length - 1 ? "1px solid #eee" : "none",
                                }}
                              >
                                {value}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    {selectedProject.brochure && (
                      <div className="mt-4 pt-3 border-top">
                        <h6 className="fw-semibold mb-3">
                          <i className="fas fa-file-pdf me-2" style={{ color: "#dc3545" }}></i>Documents:
                        </h6>
                        <button
                          className="btn w-100"
                          onClick={() => handleBrochureDownload(selectedProject)}
                          style={{
                            background: "#b8860b",
                            color: "#fff",
                            border: "none",
                            borderRadius: "0px",
                            padding: "12px 20px",
                            fontWeight: "500",
                          }}
                        >
                          <i className="fas fa-download me-2"></i>Download Project Brochure
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <Whatsapp />
      <Footer />
    </div>
  );
};

export default CompletedProjects;
